export default __webpack_public_path__ + "static/media/caret-icon.5bbf9e87.svg";